import { PropertyType } from '@domain-group/fe-allhomes-library';
import { ga4 } from '@domain-group/fe-co-allhomes-analytics';
export var agencySideboxClick = (agencyId, agencyName) => ga4.ga4event('cta_driver', {
  element_position: 'RHS sticky sidebox',
  element_target_category_primary: 'Find an Agent',
  element_target_page_type: 'Agency Profile',
  element_type: 'button',
  element_text: agencyName,
  agency_name: agencyName,
  agency_id: agencyId
});
export var agencyEnquiryClick = (agencyId, agencyName) => ga4.ga4event('cta_driver', {
  element_position: 'bottom LHS',
  element_target_category_primary: 'Find an Agent',
  element_target_page_type: 'Agency Profile',
  element_type: 'button',
  element_text: agencyName,
  element_title: 'Contact agennts',
  agency_name: agencyName,
  agency_id: agencyId
});
export var agentProfileSideboxClick = (agentId, agentName, agencyId, agencyName) => ga4.ga4event('cta_driver', {
  element_position: 'RHS sticky sidebox',
  element_target_category_primary: 'Find an Agent',
  element_target_page_type: 'Agency Profile',
  element_type: 'button',
  element_text: agentName,
  agency_name: agencyName,
  agency_id: agencyId,
  agency_agent_name: agentName,
  agency_agent_id: agentId
});
export var agentProfileEnquiryClick = (agentId, agentName, agencyId, agencyName) => ga4.ga4event('cta_driver', {
  element_position: 'bottom LHS',
  element_target_category_primary: 'Find an Agent',
  element_target_page_type: 'Agency Profile',
  element_type: 'button',
  element_text: agentName,
  element_title: 'Contact agents',
  agency_name: agencyName,
  agency_id: agencyId,
  agency_agent_name: agentName,
  agency_agent_id: agentId
});
export var viewMoreClick = () => ga4.ga4event('click_tap', {
  element_position: 'property description',
  element_type: 'button',
  element_text: 'view more'
});
export var shareButtonClick = (type, position, category, title) => {
  var eventType = 'cta_driver';
  var source;
  var elementTitle = title;
  if (type === 'Facebook' || type === 'Twitter') {
    eventType = 'share';
    source = type;
    elementTitle = 'social icon';
  }
  return ga4.ga4event(eventType, {
    element_is_modal: false,
    element_list_name: 'share options',
    element_list_position: position,
    element_position: 'RHS sticky sidebox',
    element_target_anchor_link: false,
    element_target_category_primary: category,
    element_target_page_type: type === 'Email' ? 'Index' : '',
    element_text: source || '',
    element_title: elementTitle,
    element_type: 'svg icon',
    method: source
  });
};
export var addToWatchlist = _ref => {
  var _PropertyType$propert;
  var address = _ref.address,
    features = _ref.features,
    listing = _ref.listing;
  var propertyTypeEnum = features.propertyType;
  var propertyType = ((_PropertyType$propert = PropertyType[propertyTypeEnum]) === null || _PropertyType$propert === void 0 ? void 0 : _PropertyType$propert.label) || propertyTypeEnum;
  return ga4.ga4event('shortlist_add', {
    element_is_modal: false,
    element_position: 'map',
    element_target_anchor_link: false,
    element_text: 'Add to watchlist',
    element_type: 'svg star icon',
    property_loc_address: address.formattedFull,
    property_bathrooms: features.bathrooms.total,
    property_bedrooms: features.bedrooms,
    property_parking: features.parking.total,
    property_type: propertyType,
    listing_price: listing.price
  });
};
export var addInspectionToCalendar = (listName, listPosition, position, text, title, type) => ga4.ga4event('calendar_inspection_add', {
  element_is_modal: false,
  element_list_name: listName,
  element_list_position: listPosition,
  element_position: position,
  element_target_anchor_link: false,
  element_text: text,
  element_title: title,
  element_type: type
});
export var sendEnquiry = (_ref2, options) => {
  var _agencies$, _agencies$2, _agents$;
  var agencies = _ref2.agencies,
    agents = _ref2.agents;
  return ga4.ga4event('form_submit', {
    element_is_modal: false,
    element_position: 'bottom LHS',
    element_target_anchor_link: false,
    element_text: 'Submit Enquiry',
    element_title: 'Please send me information',
    element_type: 'button',
    element_values_selected: options.join(', '),
    agency_id: (_agencies$ = agencies[0]) === null || _agencies$ === void 0 ? void 0 : _agencies$.agencyId,
    agency_name: (_agencies$2 = agencies[0]) === null || _agencies$2 === void 0 ? void 0 : _agencies$2.name,
    agency_agent_name: agents.map(agent => agent.name).join(', '),
    agency_agent_id: (_agents$ = agents[0]) === null || _agents$ === void 0 ? void 0 : _agents$.agentId,
    lead_type: 'form'
  });
};
export var nearbySalesClick = () => ga4.ga4event('search', {
  element_is_modal: false,
  element_position: 'middle',
  element_target_anchor_link: false,
  element_target_category_primary: 'Buy',
  element_target_page_type: 'Search Page',
  element_text: 'View properties',
  element_title: 'Nearby sales',
  element_type: 'button'
});
export var callReveal = (key, agentId, agentName, agencyId, agencyName, index) => {
  var isSidebox = key.includes('agent-sidebox');
  return ga4.ga4event('generate_lead', {
    element_is_modal: false,
    element_list_name: isSidebox ? 'contact agent options' : 'contact agents',
    element_list_position: index || index === 0 ? index + 1 : 0,
    element_position: isSidebox ? 'RHS sticky sidebox' : 'bottom LHS',
    element_target_anchor_link: false,
    element_text: 'Call',
    element_title: isSidebox ? '' : 'Contact agents',
    element_type: 'button',
    agency_id: agencyId,
    agency_name: agencyName,
    agency_agent_name: agentName,
    agency_agent_id: agentId,
    lead_type: 'phone'
  });
};
export var inspectionPlannerLinkClick = () => ga4.ga4event('cta_driver', {
  element_is_modal: false,
  element_position: 'LHS middle',
  element_target_anchor_link: false,
  element_target_category_primary: 'Inspection Planner',
  element_target_page_type: 'Index',
  element_text: 'View my Inspection Planner',
  element_title: 'Inspections',
  element_type: 'button'
});
export var addInspectionToPlanner = (listPosition, title) => ga4.ga4event('calendar_inspection_add', {
  element_is_modal: false,
  element_list_name: 'Inspections',
  element_list_position: listPosition,
  element_position: 'LHS middle',
  element_target_anchor_link: false,
  element_text: 'Add to planner',
  element_title: title,
  element_type: 'button'
});